import { defineStore } from 'pinia'

export default defineStore({
  id: 'distributingPage',
  persist: true,
  state: () => {
    return {
      journeyFilters: {
        search: ''
      }
    }
  },
  actions: {
    getJourneyFilters: (state: any) => state.journeyFilters
  },
  getters: {
    setJourneyFilters: function (payload: any) {
      Object.assign(this.journeyFilters, payload || {})
    }
  }
})
